export default __webpack_public_path__ + "static/media/MH_1.5c657a8c.png";